import React, { useEffect, useRef, useState } from 'react';
import './AudioPlayer.css';

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 5v14l11-7z"/>
  </svg>
);

const PauseIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
  </svg>
);

const AudioPlayer: React.FC = () => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    // Try to play audio when component mounts
    audio.play().then(() => {
      setIsPlaying(true);
    }).catch((error) => {
      console.log("Audio autoplay failed:", error);
      setIsPlaying(false);
    });

    return () => {
      audio.pause();
    };
  }, []);

  const togglePlay = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className={`audio-player ${isPlaying ? 'playing' : ''}`}>
      <audio
        ref={audioRef}
        src="/assets/audio/background-music.mp3"
        loop
      />
      <div className="vinyl-record">
        <div className="vinyl-label">
          <button 
            onClick={togglePlay}
            className="audio-control"
            aria-label={isPlaying ? 'Pause music' : 'Play music'}
          >
            {isPlaying ? <PauseIcon /> : <PlayIcon />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AudioPlayer;
